import axios from 'actions/video-obs/axiosConfig';
import { GetNextVideoResponse, RejectVideoParams } from './types';

// GET /api/v1/double_coders/next_video
export function getNextVideo() {
  return axios.get<GetNextVideoResponse>(`/api/v1/double_coders/next_video`);
}

// POST /api/v1/double_coders/video_uploads/:id/claim
export function claimVideo(videoUploadId: number) {
  return axios.post(
    `/api/v1/double_coders/video_uploads/${videoUploadId}/claim`
  );
}

// POST /api/v1/double_coders/video_uploads/:id/reject
export function rejectVideo(videoUploadId: number, params: RejectVideoParams) {
  return axios.post<RejectVideoParams>(
    `/api/v1/double_coders/video_uploads/${videoUploadId}/reject`,
    params
  );
}
